import React, { useEffect, useMemo, useState } from "react";
import stylesInputLabel from "../../styles/Atoms/InputLabel/label";

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Checkbox,
  FormGroup,
  FormHelperText,
} from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const InputCheckboxes = ({
  label,
  options = [],
  color,
  value = [],
  setValue = () => {},
  hdlOnFocus = () => {},
  hdlOnChange = () => {},
  validate = () => "",
  errorText = "",
  disabled = false,
  fontSize = "14px",
  direction = "vertical", // vertical | horizontal
  spacing = "12px",
}) => {
  const colorDefecto = color ?? "#708198";

  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    const error = validate(value);
    setValidationError(error || "");
  }, [value, validate]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: colorDefecto,
          },
        },
      }),
    [colorDefecto]
  );

  const handleCheckboxChange = (selectedValue) => {
    let updatedValues = [];

    if (value.includes(selectedValue)) {
      updatedValues = value.filter((item) => item !== selectedValue);
    } else {
      updatedValues = [...value, selectedValue];
    }

    setValue(updatedValues);
    hdlOnChange(updatedValues);

    const error = validate(updatedValues);
    setValidationError(error || "");
  };

  return (
    <ThemeProvider theme={theme}>
      <FormControl
        component="fieldset"
        error={Boolean(validationError || errorText)}
        disabled={disabled}
      >
        {label && (
          <FormLabel
            component="legend"
            sx={{
              ...stylesInputLabel.label,
              color: `${colorDefecto} !important`,
              fontWeight: 600,
              fontFamily: "Raleway, sans-serif",
              marginBottom: "10px",
            }}
          >
            {label}
          </FormLabel>
        )}

        <FormGroup
          row={direction === "horizontal"}
          sx={{
            gap: spacing,
          }}
        >
          {options.map((option, index) => (
            <FormControlLabel
              key={`${option.value}-${index}`}
              onFocus={disabled ? undefined : hdlOnFocus}
              control={
                <Checkbox
                  checked={value.includes(option.value)}
                  onChange={() => handleCheckboxChange(option.value)}
                  color="primary"
                  size="medium"
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 22,
                    },
                  }}
                />
              }
              label={option.label}
              sx={{
                margin: 0,

                "& .MuiFormControlLabel-label": {
                  fontFamily: "Raleway, sans-serif",
                  fontSize,
                  color: disabled ? "#999" : "#708198",
                  fontWeight: 500,
                },
              }}
            />
          ))}
        </FormGroup>

        {(validationError || errorText) && (
          <FormHelperText
            sx={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "12px",
              marginTop: "5px",
            }}
          >
            {validationError || errorText}
          </FormHelperText>
        )}
      </FormControl>
    </ThemeProvider>
  );
};

export default InputCheckboxes;